<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <div class="area_wrap">
          <div class="banner_wrap">
            <p v-html="getBannerDetail.content"></p>
          </div>
        </div>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import errorParser from '@/utils/error-parser'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single'
      },
      transDate: {
        headerName: '메인 소개 상세페이지',
        prevUrl: '/'
      }
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapGetters([
      'getBannerDetail'
    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    async fetchData () {
      try {
        await this.BANNER_DETAIL()
          .then(() => {
          })
      } catch (error) {
        console.log('error :', error);
        console.log('배너 디테일 API에서 에러남')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapActions([
      'BANNER_DETAIL'
    ])
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  }
}
</script>

<style lang="scss" scoped>
</style>
